import React from 'react';

import { Icon } from '@chakra-ui/react';

export const PolicyUserIcon = props => (
  <Icon viewBox="0 0 723 720" w="full" h="full" color="inherit" {...props}>
    <g transform="translate(-278 0)">
      <g>
        <g>
          <g>
            <g>
              <path
                d="M400.145 642.001 400.145 78C400.145 68.0588 408.204 60 418.144 60L767.692 60C772.463 60 777.041 61.8964 780.416 65.2721L874.874 159.728C878.249 163.104 880.145 167.682 880.145 172.456L880.145 642.001C880.145 651.942 872.087 660 862.144 660L418.144 660C408.204 660 400.145 651.942 400.145 642.001Z"
                stroke="currentColor"
                strokeWidth="16.0101"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                transform="matrix(1.00076 0 0 1 -1.06613 0)"
              />
              <path
                d="M760.145 162 760.145 70.6065C760.145 64.7488 764.893 60 770.752 60 773.565 60 776.262 61.1174 778.255 63.1066L877.039 161.894C879.028 163.882 880.145 166.58 880.145 169.393 880.145 175.251 875.398 180 869.536 180L778.144 180C768.204 180 760.145 171.941 760.145 162Z"
                stroke="currentColor"
                strokeWidth="16.0101"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00076 0 0 1 -1.06613 0)"
              />
              <path
                d="M758.182 529.164C752.049 529.164 747.101 524.212 747.101 518.083L747.101 488.55C747.101 462.057 725.556 440.57 699.119 440.57L580.937 440.57C554.444 440.57 532.957 462.115 532.957 488.55L532.957 518.083C532.957 524.212 528.006 529.164 521.876 529.164 515.744 529.164 510.793 524.212 510.793 518.083L510.793 488.55C510.793 449.85 542.237 418.409 580.937 418.409L699.063 418.409C737.763 418.409 769.207 449.85 769.207 488.55L769.207 518.083C769.207 524.212 764.256 529.164 758.182 529.164ZM640 381.452C601.3 381.452 569.856 350.007 569.856 311.308 569.856 272.607 601.3 241.164 640 241.164 678.7 241.164 710.144 272.607 710.144 311.308 710.144 350.007 678.7 381.452 640 381.452ZM640 263.326C613.507 263.326 592.017 284.87 592.017 311.308 592.017 337.745 613.562 359.287 640 359.287 666.438 359.287 687.982 337.745 687.982 311.308 687.982 284.87 666.493 263.326 640 263.326Z"
                stroke="currentColor"
                strokeWidth="16.0101"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00076 0 0 1 -1.06613 0)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
);
